<template>
  <div class="countdown">
    <div v-if="msTime.show" class="countdown-text">
      <span class="countdown-tip-text">{{tipText}}</span>
      <div class="timer-count">
        <span class="timer-count-day" v-if="msTime.day>0"><span>{{msTime.day}}</span><i>{{dayTxt}}</i></span>
        <div class="timer-count-content">
          <span>{{msTime.hour}}</span><i>{{hourTxt}}</i>
          <span>{{msTime.minutes}}</span><i>{{minutesTxt}}</i>
          <span>{{msTime.seconds}}</span><i>{{secondsTxt}}</i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  let timer = null;
  export default {
    data () {
      return {
        tipShow: true,
        msTime: {			//倒计时数值
          show: false,		//倒计时状态
          day: '',			//天
          hour: '',		//小时
          minutes: '',		//分钟
          seconds: ''		//秒
        },
        timeRemaining: this.timeDistance,
        interval: 1000,
      }
    },
    watch: {
      isClear(val) {
        if (val) {
          this.clearTimer();
        }
      },
      timeDistance(newVal) {
        this.timeRemaining = newVal;
        this.gogogo();
      }
    },
    props: {
      isClear:{
        type: Boolean,
        default: false
      },
      //距离开始提示文字
      tipText: {
        type: String,
        default: '距离开始'
      },
      //自定义显示文字:天
      dayTxt: {
        type: String,
        default: ':'
      },
      //自定义显示文字:时
      hourTxt: {
        type: String,
        default: ':'
      },
      //自定义显示文字:分
      minutesTxt: {
        type: String,
        default: ':'
      },
      //自定义显示文字:秒
      secondsTxt: {
        type: String,
        default: ''
      },
      // 剩余时间
      timeDistance:{
        type: Number
      },
    },
    mounted() {
      this.gogogo();
    },
    methods: {
      clearTimer() {
        clearTimeout(timer);
      },
      gogogo() {
        /**
         * 结束时间大于当前并且开始时间小于当前时间，执行活动开始倒计时
         */
        this.clearTimer();
        this.msTime.show = true;
        this.$emit('start_callback', this.msTime.show);
        this.runTime(this.timeRemaining, this.end_message);
      },
      runTime(timeRemaining, callFun) {
        let msTime = this.msTime;
        if (timeRemaining > 0) {
          msTime.day = Math.floor(timeRemaining / 86400000);
          timeRemaining -= msTime.day * 86400000;
          msTime.hour = Math.floor(timeRemaining / 3600000);
          timeRemaining -= msTime.hour * 3600000;
          msTime.minutes = Math.floor(timeRemaining / 60000);
          timeRemaining -= msTime.minutes * 60000;
          msTime.seconds = Math.floor(timeRemaining / 1000).toFixed(0);
          timeRemaining -= msTime.seconds * 1000;
          if (msTime.day < 10) {
            msTime.day = "0" + msTime.day;
          }
          if (msTime.hour < 10) {
            msTime.hour = "0" + msTime.hour;
          }
          if (msTime.minutes < 10) {
            msTime.minutes = "0" + msTime.minutes;
          }
          if (msTime.seconds < 10) {
            msTime.seconds = "0" + msTime.seconds;
          }
          this.clearTimer();
          timer = setTimeout(() => {
            this.runTime(this.timeRemaining -= this.interval, callFun);
          }, this.interval)
        } else {
          callFun && callFun();
          this.clearTimer();
          this.$emit('countOver');
        }
      },
      end_message() {
        this.msTime.show = false;
        this.$emit('end_callback', this.msTime.show);
      }
    }
  }
</script>

<style scoped lang='less'>
  .countdown {
    color:#fff;
    font-size: 24px;
    text-align: center;
    .countdown-text {
      display: flex;
      padding: 0;
      margin: 0;
      align-items: center;
      justify-content: center;
    }
    .timer-count-day {
      margin-right: 6px;
    }
    .countdown-tip-text {
      line-height: 30px;
      margin-right: 8px;
    }
    .timer-count-content {
      width: 100px;
    }
    .timer-count {
      text-align: left;
      display: flex;
    }
    i {
      font-style: normal;
    }
  }
</style>
 